import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

import { Abono } from './abono'
import { Afastamento } from './afastamentos'
import { CompensacaoDia } from './feriados'
import { Local } from './locais'

export type Registro = z.infer<typeof zod.RegistroSchema> & {
    Local?: Local
    Funcionario?: { id?: number; nome?: string; codigo?: number }
    excluidoPor?: string
    motivoExclusao?: string
    nomeOrigem?: string
    centroCustoId?: number
    centroCustoNome?: string
    localId?: number
    localNome?: string
    _centroCustoNome?: string
    _localNome?: string
    _funcionarioNome?: string
    _dataLabel?: string
}

export type AllRegistriesQuery = {
    competencia: string
    id: string | number
}

export type AllRegistries = {
    dia: string
    registros: Registro[]
    afastamento?: Afastamento
    abono?: Abono
    compensacao?: CompensacaoDia
}

type Service = Omit<Registro, 'repId' | 'nsr' | 'localId'>

const service = new ApiService<Service, Registro>('registros')

export const registros = Object.assign(service, {
    aprovacao: new ApiService<Service, Registro>('registros/aprovacao'),
    reprovacao: new ApiService<Service, Registro>('registros/reprovacao'),
    pendentes: new ApiService<Service, Registro>('registros/pendentes'),
    foraCerca: new ApiService<Service, Registro>('registros/fora-cerca'),
    excluidos: new ApiService<Service, Registro>('registros/excluidos'),
    relatorioFicha: new ApiService<Service, Registro>(
        'registros/pdf-ficha-ponto',
    ),
})
